/**
 * A tiny in-page event bus so anything (the notification poll, a finished export, a timer) can
 * make the Dynamic Island announce something without importing the island.
 */
export interface IslandAlert {
  id: string
  title: string
  body?: string | null
  /** App-relative link, opened when the alert is clicked. */
  href?: string | null
  /** External link (e.g. a Meet/Zoom call), opened in a new tab when the alert is clicked. */
  url?: string | null
  tone?: 'info' | 'success' | 'warning' | 'danger'
}

type Listener = (alert: IslandAlert) => void
const listeners = new Set<Listener>()

export function announce(alert: IslandAlert): void {
  listeners.forEach((fn) => fn(alert))
}

export function onAnnounce(fn: Listener): () => void {
  listeners.add(fn)
  return () => {
    listeners.delete(fn)
  }
}

/** True while an island is mounted and listening; callers can fall back to a toast otherwise. */
export function islandListening(): boolean {
  return listeners.size > 0
}
